// Based on https://github.com/imcvampire/vue-axios/blob/master/src/index.js
export function vueAxiosPlugin(app, options) {
    const key = '$http';
    Object.defineProperty(app.prototype, key, {
        get() {
            return options;
        }
    });
    app[key] = options;
}